import React from 'react';
import { FormikProps } from 'formik';
import { FormattedMessage } from 'react-intl';
import FormikRadioGroup from './FormikRadioGroup';
import { FEEDBACK_RESPONSE } from '../constants';

interface YesNoNARadioGroupProps {
  formik: FormikProps<any>;
  fieldName: string;
  disabled?: boolean;
}

const YesNoNARadioGroup: React.FC<YesNoNARadioGroupProps> = ({
  formik,
  fieldName,
  disabled = false,
}) => {
  const options = [
    {
      value: FEEDBACK_RESPONSE.YES,
      label: (
        <FormattedMessage
          id='cs_perfportal_summaries_manager_feedback_yes'
          defaultMessage='Yes'
        />
      ),
    },
    {
      value: FEEDBACK_RESPONSE.NO,
      label: (
        <FormattedMessage
          id='cs_perfportal_summaries_manager_feedback_no'
          defaultMessage='No'
        />
      ),
    },
    {
      value: FEEDBACK_RESPONSE.NA,
      label: (
        <FormattedMessage
          id='cs_perfportal_summaries_manager_feedback_na'
          defaultMessage='N/A'
        />
      ),
    },
  ];

  return (
    <FormikRadioGroup
      formik={formik}
      fieldName={fieldName}
      options={options}
      disabled={disabled}
    />
  );
};

export default YesNoNARadioGroup;
